import { ServiceResponse } from '@/models/ServiceResponse'
import { ReservationRequest, ReservationResult } from '@/types/ReservationRequest'
import { api } from './Api'

class RegistrationService {
  public async createReservation(request: ReservationRequest): Promise<ServiceResponse<ReservationResult>> {
    const response = await api.post<ReservationRequest, ReservationResult>('/api/reservations', request)
    return new ServiceResponse(response, response.data)
  }

  public async deleteReservation(
    calendarFile: string,
    gameId: string,
    seatId: string
  ): Promise<ServiceResponse<ReservationResult>> {
    const url = `/api/reservations/${encodeURIComponent(gameId)}/${encodeURIComponent(seatId)}?filename=${encodeURIComponent(calendarFile)}`
    const response = await api.delete<ReservationResult>(url)
    return new ServiceResponse(response, response.data)
  }
}

export const registrationService = new RegistrationService()
